var cov_18l4d0o0az = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Rate/styles/index.ts",
      hash = "0ecab80dd84b685f49ba3dbc6d6e775ba2e0ec72",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Rate/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var rateLess = {};
import genaration from '../../utils/classname';
export var rateClass = (cov_18l4d0o0az.s[0]++, genaration(rateLess, 'rate'));